<template>
  <div>
    <div class="left-panel" @scroll="onScrollLeftPanel">
      <div class="heading">
        <span>{{ providerName }}</span>
        <div class="switch">
          <div :class="{'slider':true, 'active':isActive, 'disabled':showActiveModal || !editEnabled}"
            @click="confirmModal"></div>
          <span class="label" v-show="isActive">{{ $t('provider.active') }}</span>
          <span class="label" v-show="!isActive">{{ $t('provider.deactive') }}</span>
        </div>
        <div class="prov-options"
          @mouseover="clearOptionDelay" @mouseout="hideOptions">
          <i class="fas fa-ellipsis-v fa-lg" @click="showOptions = !showOptions"></i>

          <transition name="slide-down">
            <div class="options" v-show="showOptions">
              <div class="button cta success block call" @click="call(providerData)">
                <i class="fa fa-phone"></i>{{ $t('provider.call') }}
              </div>
              <div class="button cta block send-sms" @click="sendSMS(providerData)">
                <i class="fas fa-comment-dots"></i>{{ $t('provider.sms') }}
              </div>
              <div class="button cta warning block send-notif" @click="showNotif">
                <i class="fas fa-bell"></i>{{ $t('provider.notify') }}
              </div>
              <div class="button cta block print-placard" @click="printPlacard" v-if="isTnc">
                <i class="far fa-address-card"></i>{{ $t('provider.print') }}
              </div>
              <div class="button cta block error download-profile" @click="dlProfile('op')" v-if="isBefore2026(created)">
                <i class="fas fa-file-download"></i>Download Profile
                <span>(OP)</span>
              </div>
              <div class="button cta block error download-profile" @click="dlProfile('ptrs')">
                <i class="fas fa-file-download"></i>Download Profile
                <span v-if="isBefore2026(created)">(PTRS)</span>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <ul class="tab">
        <li :class="{'active':activeTab.left === 0}" @click="switchTab('left', 0)"> <!-- v-if="editEnabled" -->
          {{ $t('provider.tabLabel.accountDetails') }}
        </li>
        <li :class="{'active':activeTab.left === 5}" @click="switchTab('left', 5)" v-if="!useOldQuatation">
          {{ $t('provider.tabLabel.services') }}
        </li>
        <!-- <li :class="{'active':activeTab.left === 1}" @click="switchTab('left', 1)">
          {{ $t('provider.tabLabel.payout') }}
        </li> -->
        <li :class="{'active':activeTab.left === 2}" @click="switchTab('left', 2)">
          {{ $t('provider.tabLabel.availability') }}
        </li>
        <li :class="{'active':activeTab.left === 3}" @click="switchTab('left', 3)">
          {{ $t('provider.tabLabel.reviews') }}
        </li>
        <li :class="{'active':activeTab.left === 4}" @click="switchTab('left', 4)">
          {{ $t('provider.tabLabel.notes') }}
        </li>
      </ul>

      <div class="tab-contents">
        <div :class="{'tab-content':true, 'active':activeTab.left == 0}">
          <account-details ref="accountDetails"
            :basicInfoImg="basicInfoImg" :vehicleInfoImg="vehicleInfoImg"
            :nextDrvrId="nextDriverId"
            ></account-details>
        </div>
        <div :class="{'tab-content':true, 'active':activeTab.left == 5}" v-if="!useOldQuatation">
          <services ref="services" :_licenseType="licenseType"></services>
        </div>
        <!-- <div :class="{'tab-content':true, 'active':activeTab.left == 1}">
          <driver-payouts :provId="$route.params.id"></driver-payouts>
        </div> -->
        <div :class="{'tab-content':true, 'active':activeTab.left == 2}">
          <driver-shifts ref="shifts" :active="activeTab.left == 2"></driver-shifts>
        </div>
        <div :class="{'tab-content':true, 'active':activeTab.left == 3}">
          <reviews ref="reviews" :active="activeTab.left == 3"></reviews>
        </div>
        <div :class="{'tab-content':true, 'active':activeTab.left == 4}">
          <notes ref="notes" :active="activeTab.left == 4"></notes>
        </div>
      </div>

      <div class="fix-buttons" v-show="((activeTab.left === 0 || activeTab.left === 5) && editEnabled) || activeTab.left === 4">
        <a :class="{'button cta small success':true, 'disabled':formHasError}"
          v-if="activeTab.left === 0" @click="triggerSave">
          <span v-if="!formLoading">{{ $t('provider.save') }}</span>
          <span v-else>
            <i class="fa fa-spinner fa-spin fa-fw"></i>
            {{ $t('provider.saving') }}
          </span>
        </a>

        <a class="button cta small success right" v-if="activeTab.left === 4"
          @click="AddNotes">
          {{ $t('provider.addNotes') }}
        </a>

        <a :class="{'button cta small success center':true, 'disabled':serviceSave.loading}"
          v-if="activeTab.left === 5" @click="saveServices">
          <span v-if="serviceSave.loading">
            <i class="fa fa-spinner fa-spin fa-fw"></i>
            {{ $t('provider.saving') }}
          </span>
          <span v-else>Save</span>
        </a>
      </div>
    </div>
    <div class="toggle-mobile" @click="showRecords = !showRecords">
      <span v-if="!showRecords">Show Records <i class="fa fa-chevron-up"></i></span>
      <span v-else>Hide Records <i class="fa fa-chevron-down"></i></span>  
    </div>

    <div :class="['right-panel', showRecords ? 'mobile-right-panel' : '']" @scroll="onScrollRsvp">
      <!-- <div class="heading">
        <span>{{ $t('provider.provReservation', {provider: providerData.firstName }) }}</span>
      </div> -->

      <ul class="tab">
        <li :class="{'active':activeTab.right === 0}" @click="switchTab('right', 0)">
          {{ $t('provider.tabLabel.upcoming') }}
        </li>
        <li :class="{'active':activeTab.right === 1}" @click="switchTab('right', 1)">
          {{ $t('provider.tabLabel.completed') }}
        </li>
        <li :class="{'active':activeTab.right === 2}" @click="switchTab('right', 2)" v-if="editEnabled">
          {{ $t('provider.tabLabel.payout') }}
        </li>
        <li :class="{'active':activeTab.right === 3}" @click="switchTab('right', 3)" v-if="editEnabled">
          Doc History
        </li>
      </ul>

      <div class="tab-contents">
        <div :class="{'tab-content':true, 'active':activeTab.right == 0}">
          <reservations type="upcoming" :active="activeTab.right == 0"
            ref="upcoming"></reservations>
        </div>
        <div :class="{'tab-content':true, 'active':activeTab.right == 1}">
          <reservations type="history" :active="activeTab.right == 1"
            ref="history"></reservations>
        </div>

        <div :class="{'tab-content':true, 'active':activeTab.right == 2}" v-if="editEnabled">
          <payouts :active="activeTab.right == 2"></payouts>
        </div>

        <div :class="{'tab-content':true, 'active history-panel':activeTab.right == 3}" v-if="editEnabled">
          <doc-history :active="activeTab.right == 3"></doc-history>
        </div>

        <transition name="slide-up">
          <div class="fixed-footer"
            v-show="(activeTab.right == 0 && hasUpcoming) || (activeTab.right == 1 && hasHistory)">
            {{ $t('provider.reservations.totalDriverPayment') }}:
            <span @click="showBreakdown"
              v-if="(hasUpcoming && !totalDriverPayment.upcomingLoading) || (hasHistory && !totalDriverPayment.historyLoading)">
              <b v-if="activeTab.right == 0">${{ toFixed(totalDriverPayment.upcoming) }}</b>
              <b v-else>${{ toFixed(totalDriverPayment.history) }}</b>
              <!-- <i class="far fa-address-card"></i> -->
              <i class="fas fa-receipt"></i>
            </span>
            <span v-else>
              <i class="fas fa-sync-alt fa-spin"></i>
            </span>
          </div>
        </transition>
      </div>

      <div class="logs">
        <div class="trigger">
          <a :class="{'logs-toggle':true, on:showLogs}" @click="toggleLogs"><i :class="logsIcon"></i></a>
        </div>
        <div :class="{'logs-panel':true, hide:!showLogs}">
          <!-- <div class="heading">
            Logs
            <select v-model="logDate" :disabled="logsLoading" :class="{'disabled':logsLoading}">
              <option value="all">All</option>
              <option value="custom">Custom</option>
            </select>
          </div> -->
          <logs ref="logs"></logs>
        </div>
      </div>
    </div>

    <loading-modal :showModal="loading" modalMessage="Loading"></loading-modal>

    <div :class="{'modal':true, 'show':showActiveModal}">
      <div class="modal-content active-confirmation">
        <p v-show="!isActive" v-html="$t('provider.modal.toActivate', {provider: providerName})"></p>
        <p v-show="isActive" v-html="$t('provider.modal.toDeactivate', {provider: providerName})"></p>
        <div class="button cta warning" @click="showActiveModal = false">{{ $t('provider.modal.no') }}</div>
        <div class="button cta success" @click="toggleProvActive">
          <span v-show="!statusLoading">{{ $t('provider.modal.yes') }}</span>
          <i class="fa fa-spinner fa-spin" v-show="statusLoading"></i>
        </div>
      </div>
    </div>

    <div :class="{'modal':true, 'show':formResult.isDone}">
      <div class="bg-overlay" @click="closeFormResult"></div>
      <div class="modal-content formResult">
        <p>{{ formResult.message }}</p>

        <a class="button cta warning block small" @click="closeFormResult">
          {{ $t('provider.close') }}
        </a>
      </div>
    </div>

    <div :class="{'modal':true, 'show':showUpload, 'no-preview':!showUploadPreview}">
      <div class="bg-overlay" @click="closeUploadForm"></div>
      <div class="modal-content upload">
        <input type="file" name="image" accept="image/*"
          @change="setImage" class="input-file" ref="fileInput"
        />
        <div class="cropper-wrap" v-show="showUploadPreview">
          <div class="upload-side">
            <span class="_label">Selected Image:</span>
            <vue-cropper
              ref='cropper'
              :guides="false"
              drag-mode="crop"
              :zoom="updateCropPreview"
              :cropmove="updateCropPreview"
              :view-mode="2"
              :min-container-width="420"
              :min-container-height="380"
              :background="true"
              :src="canvasUrl"
              alt=" "
              :img-style="{ width: '420px', 'height': '380px' }"
            ></vue-cropper>
            <!-- :cropBoxResizable="false" -->
          </div>
          <div class="preview-side">
            <span class="_label">Preview Image:</span>
            <img :src="previewUrl" />
          </div>
        </div>
        <a :class="{'button cta warning small':true, 'disabled':uploadLoading }"
          @click="closeUploadForm">
          {{ $t('provider.cancel') }}
        </a>
        <a :class="{'button cta success small':true, 'disabled':uploadLoading }"
          @click="cropImage">
          <span v-show="!uploadLoading">{{ $t('provider.upload') }}</span>
          <span v-show="uploadLoading">
            <i class="fa fa-spinner fa-spin"></i>
            {{ $t('provider.uploading') }}
          </span>
        </a>
      </div>
    </div>

    <div :class="{'modal':true, 'show':showUploadError}">
      <div class="bg-overlay" @click="closeUploadError"></div>
      <div class="modal-content uploadError">
        <p>
          <i class="fa fa-frown fa-5x"></i>
          {{ $t('provider.uploadError') }}
        </p>

        <a class="button cta warning block small" @click="closeUploadError">
          {{ $t('provider.close') }}
        </a>
      </div>
    </div>

    <div :class="{'modal breakdown':true, 'show':showBreakdownModal}" @click="showBreakdownModal = false">
      <div class="modal-content" @click.stop>
        <div v-if="!!breakdownError" class="has-error">
          <i class="far fa-frown fa-4x"></i>
          <span>Something went wrong!</span>
          <p>{{breakdownError}}</p>
        </div>
        <div v-else-if="showBreakdownModal">
          <div class="label">Breakdown</div>
          <table cellspacing="0" class="list">
            <thead>
              <td></td>
              <td>Fare</td>
              <td>Fuel Surcharge</td>
              <td>Pickup Fee</td>
              <td>Payment Bonus</td>
              <td>Tip</td>
              <td>Release Bonus</td>
              <td>Deductions</td>
            </thead>
            <tbody>
              <tr v-for="(data, index) in breakdownList[activeTable]">
                <td>
                  <a :class="{'pkg':data.type !== 'RSVP'}"
                    :href="'/#/' + (data.type === 'RSVP' ? 'reservation' : 'package') + '/' + data.id"
                    target="_blank">{{ data.type + ' ' + data.id }}</a>
                </td>
                <td>${{ toFixed(data.amount) }}</td>
                <td>${{ toFixed(data.gasFee) }}</td>
                <td>${{ toFixed(data.pickupFee) }}</td>
                <td>${{ toFixed(data.bonusAmount) }}</td>
                <td>${{ toFixed(data.tip) }}</td>
                <td>${{ toFixed(data.releaseBonus) }}</td>
                <td>(${{ toFixed(data.deductions) }})</td>
              </tr>
              <tr class="total">
                <td></td>
                <td>${{ toFixed(totalBreakdown('amount')) }}</td>
                <td>${{ toFixed(totalBreakdown('gasFee')) }}</td>
                <td>${{ toFixed(totalBreakdown('pickupFee')) }}</td>
                <td>${{ toFixed(totalBreakdown('bonusAmount')) }}</td>
                <td>${{ toFixed(totalBreakdown('tip')) }}</td>
                <td>${{ toFixed(totalBreakdown('releaseBonus')) }}</td>
                <td>(${{ toFixed(totalBreakdown('deductions')) }})</td>
              </tr>
            </tbody>
          </table>
          <table class="computations">
            <tr>
              <td>Amount</td>
              <td>${{ toFixed(totalBreakdown('amount')) }}</td>
            </tr>
            <tr>
              <td>Fuel Surcharge</td>
              <td>${{ toFixed(totalBreakdown('gasFee')) }}</td>
            </tr>
            <tr>
              <td>Pickup Fee</td>
              <td>${{ toFixed(totalBreakdown('pickupFee')) }}</td>
            </tr>
            <tr>
              <td>Payment Bonus</td>
              <td>${{ toFixed(totalBreakdown('bonusAmount')) }}</td>
            </tr>
            <tr>
              <td>Tip</td>
              <td>${{ toFixed(totalBreakdown('tip')) }}</td>
            </tr>
            <tr>
              <td>Release Bonus</td>
              <td>${{ toFixed(totalBreakdown('releaseBonus')) }}</td>
            </tr>
            <tr>
              <td>Deductions</td>
              <td>(${{ toFixed(totalBreakdown('deductions')) }})</td>
            </tr>
            <tr class="total">
              <td colspan="2">${{ totalOverall() }}</td>
            </tr>
          </table>
          <div class="clear"></div>
        </div>
      </div>
    </div>

    <div :class="{'modal':true, 'show':serviceSave.modal}">
      <div class="bg-overlay" @click="closeServiceModal"></div>
      <div class="modal-content service-save">
        <i class="fas fa-check-circle fa-5x" v-if="serviceSave.success"></i>
        <i class="fas fa-times-circle fa-5x" v-else></i>
        <span v-if="serviceSave.success && serviceSave.message">No changes to provider service types.</span>
        <span v-else-if="serviceSave.success">Succesfully saved provider service!</span>
        <span v-else>Oops! Something went wrong</span>
        <p v-if="serviceSave.message && !serviceSave.success">{{ serviceSave.message }}</p>

        <a class="button cta warning block small" @click="closeServiceModal">
          {{ $t('provider.close') }}
        </a>
      </div>
    </div>

    <div :class="{'modal':true, 'show':quickRes.modal}">
      <div class="modal-content active-confirmation">
        <p v-show="!quickRes.enable">Confirm enable quick res?</p>
        <p v-show="quickRes.enable">Confirm disable quick res?</p>
        <div class="button cta warning" @click="closeQuickResModal">No</div>
        <div class="button cta success" @click="toggleQuickRes">
          <span v-show="!quickRes.loading">Yes</span>
          <i class="fa fa-spinner fa-spin" v-show="quickRes.loading"></i>
        </div>
      </div>
    </div>

    <notification-modal ref="notif"
      :isList="false" :provId="$route.params.id" :broadcastOnly="true"
      :removeAllActiveUserOption="true" :hideTargetOption="true"></notification-modal>
    <sms-modal ref="sms"
      :isList="false" :provId="$route.params.id"
      :removeAllActiveUserOption="true" :hideTargetOption="true"></sms-modal>
    <shift-form></shift-form>
    <payout-form :provId="$route.params.id"></payout-form>
    <!-- <div class="dl-profile" v-if="!loading">
      <download-profile ref="dlProfile"></download-profile>
    </div> -->
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import accountDetails from './AccountDetails'
import driverPayouts from './DriverPayouts'
// import statistics from './Statistics'
import driverShifts from './Shifts'
import shiftForm from './ShiftForm'
import reviews from './Reviews'
import notes from './Notes'
import payouts from './Payouts'
import payoutForm from './PayoutForm'
import docHistory from './DocHistory'
import services from './Services'
import reservations from './Reservations'
import notificationModal from '../App/NotificationModal'
import smsModal from '../App/SMSModal'
import logs from './Logs'
import ApiProvider from '@/modules/api/provider/user-info'
import loadingModal from '@/components/Partials/LoadingModal'
import VueCropper from 'vue-cropperjs'
import ApiProviderReservations from '@/modules/api/provider/reservations'

export default {
  name: 'provider',
  components: {
    accountDetails, driverPayouts, driverShifts, shiftForm, reviews, notes,
    reservations, loadingModal, notificationModal, smsModal, services, payouts,
    payoutForm, docHistory, logs
  },
  data () {
    return {
      activeTab: {
        left: 0,
        right: 0
      },
      loading: false,
      showActiveModal: false,
      statusLoading: false,
      canvasUrl: '',
      previewUrl: '',
      basicInfoImg: '',
      vehicleInfoImg: '',
      showUploadPreview: false,
      uploadLoading: false,
      showOptions: false,
      showOptionsDelay: '',
      isTnc: false,
      licenseType: '',
      showBreakdownModal: false,
      breakdownError: '',
      showLogs: false,
      logDate: 'all',
      showRecords: false,
      nextDriverId: ''
    }
  },
  computed: {
    provId () { return this.$route.params.id },
    isActive () { return this.$store.state.provider.active },
    basicInfo () { return this.$store.state.provider.basicInfo },
    providerData () {
      let basicInfo = this.$store.state.provider.basicInfo
      return {
        firstName: basicInfo.firstName,
        lastName: basicInfo.lastName,
        mobile: basicInfo.mobile
      }
    },
    isMax () { return this.$store.state.provider.isMax },
    providerName () { return this.providerData.firstName + ' ' + this.providerData.lastName },
    formHasError () { return this.$store.state.provider.formHasError },
    formLoading () { return this.$store.state.provider.formLoading },
    formResult () { return this.$store.state.provider.formSave },
    showUpload () { return this.$store.state.provider.upload.show },
    showUploadError () { return this.$store.state.provider.upload.error },
    hasUpcoming () { return this.$store.state.provider.upcoming.length > 0 },
    hasHistory () { return this.$store.state.provider.history.length > 0 },
    totalDriverPayment () {
      let totalDriverPayment = this.$store.state.provider.totalDriverPayment
      return {
        upcoming: totalDriverPayment.upcoming.total,
        upcomingLoading: totalDriverPayment.upcoming.loading,
        history: totalDriverPayment.history.total,
        historyLoading: totalDriverPayment.history.loading
      }
    },
    activeTable () { return this.activeTab.right === 1 ? 'history' : 'upcoming' },
    breakdownList () { return this.$store.state.provider.breakdown },
    useOldQuatation () { return CONFIG.useOldQuatation},
    serviceSave () { return this.$store.state.provider.serviceSave },
    editEnabled () { return this.$store.state.session.user.access.hasOwnProperty('PageAdminProviderEdit') },
    logsIcon () { return !this.showLogs ? 'fa fa-clipboard-list fa-2x' : 'fas fa-times fa-2x'},
    logsLoading () { return this.$store.state.provider.logs.loading },
    quickRes () { return this.$store.state.provider.quickRes },
    driverId: {
      get () { return this.$store.state.provider.driverId },
      set (x) { this.$store.commit('provider/setDriverId', x) }
    },
    driverIdLoading: {
      get () { return this.$store.state.provider.driverIdLoading },
      set (x) { this.$store.commit('provider/setDriverIdLoading', x) }
    },
    created () { return this.$store.state.provider.created }
  },
  methods: {
    init () {
      let self = this
      self.loading = true

      if (!self.editEnabled) {
        // self.activeTab.left = 2
      }
      ApiProvider.getProviderData(self, self.$route.params.id, function (res) {
        if (res.error) {
          self.$router.push({name: 'MissingPage'})
          return
        }

        self.nextDriverId = ''
        if (!res.driverNum) {
          self.getNextDriverNum()
        }

        self.isTnc = res.providerAccountType === 'tnc'
        self.licenseType = res.providerAccountType

        if (self.editEnabled && self.$refs.accountDetails.validateAll()) {
          self.$refs.accountDetails.validateAll()
        }

        if (self.editEnabled && self.$refs.services.getCheckedServices()) {
          self.$refs.services.getCheckedServices()
        }

        // if (self.$refs.shifts.initialize()) {
        //   self.$refs.shifts.initialize()
        // }

        self.loading = false
        if (window.location.href.indexOf('?payouts') > -1) {
          self.activeTab.right = 2
        }
      })
    },
    switchTab (tab, index) {
      this.activeTab[tab] = index
    },
    onScrollLeftPanel (event) {
      let self = this
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (self.activeTab.left === 3 && self.$refs.reviews.getReviews()) {
          self.$refs.reviews.getReviews()
        // } else if (self.activeTab.left === 4 && self.$refs.notes.getNotes()) {
        //   self.$refs.notes.getNotes()
        }
      }
    },
    onScrollRsvp (event) {
      let self = this
      let type = (self.activeTab.right) ? 'history' : 'upcoming'
      let isMax = self.$store.state.provider.isMax[type]
      if (isMax) { return }

      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (self.$refs[type].getReservations()) {
          self.$refs[type].getReservations()
        }
      }
    },
    call (user) {
      let self = this
      self.showOptions = false
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      })
    },
    toggleProvActive () {
      let self = this
      self.statusLoading = true
      ApiProvider.updateProviderStatus(self, {
        id: self.$route.params.id,
        isActive: !this.isActive
      }, function (res) {
        self.statusLoading = false
        self.showActiveModal = false
        self.$store.commit('provider/setActive', !self.isActive)
        if (self.$refs.logs.reload()) {
          self.$refs.logs.reload()
        }
      })
    },
    AddNotes () {
      this.$store.commit('reservationNotes/show', {
        driverId: this.$route.params.id,
        isProv: true
      })
    },
    triggerSave () {
      if (this.$refs.accountDetails.save()) {
        this.$refs.accountDetails.save()
      }
    },
    closeFormResult () {
      this.$store.commit('provider/setFormSavingDone', false)

      if (this.formResult.message.indexOf('successfully updated') > -1) {
        location.reload()
      }

      this.$store.commit('provider/setFormSaveMessage', '')
    },
    setImage (e) {
      let self = this
      const file = e.target.files[0];

      if (!file.type.includes('image/')) {
        alert('Please select an image file');
        return;
      }

      if (typeof FileReader === 'function') {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.canvasUrl = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
          self.showUploadPreview = true
          setTimeout(function () {
            self.previewUrl = self.$refs.cropper.getCroppedCanvas().toDataURL();
          }, 50)
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    cropImage () {
      let self = this
      self.$refs.cropper.getCroppedCanvas({width: 500, height: 500}).toBlob(function (blob) {
        let ref = self.$store.state.provider.upload.ref
        let fd = new FormData()
        fd.append('pic', blob, 'test.jpg')

        self.uploadLoading = true
        self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
          header: { 'Content-Type': 'multipart/form-data' }
        }).then(function (res) {
          console.log('success', res)
          self.uploadLoading = false
          self.closeUploadForm()
          if (!res.body.success) {
            self.$store.commit('provider/showUploadError', true)
            return
          }
          self[ref + 'Img'] = res.body.data.url
        }, function (res) {
          console.log('error', res)
          self.uploadLoading = false
          self.closeUploadForm()
          self.$store.commit('provider/showUploadError', true)
        });
      }, 'image/jpeg', 0.8)
    },
    updateCropPreview () {
      this.previewUrl = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    closeUploadForm () {
      if (this.uploadLoading) { return }

      this.$refs.cropper.destroy()
      this.showUploadPreview = false
      this.previewUrl = ''
      this.$refs.fileInput.value = ''

      this.$store.commit('provider/showCropper', {
        show: false,
        ref: ''
      })
    },
    closeUploadError () {
      this.$store.commit('provider/showUploadError', false)
    },
    toFixed (value) { return parseFloat(value).toFixed(2) },
    hideOptions () {
      let self = this
      self.showOptionsDelay = setTimeout(function () {
        self.showOptions = false
      }, 1500)
    },
    clearOptionDelay () {
      if (this.showOptionsDelay) { clearTimeout(this.showOptionsDelay) }
    },
    sendSMS () {
      this.showOptions = false
      if (this.$refs.sms.showSMSForm()) {
        this.$refs.sms.showSMSForm()
      }
    },
    showNotif () {
      this.showOptions = false
      if (this.$refs.notif.showNotifForm()) {
        this.$refs.notif.showNotifForm()
      }
    },
    printPlacard () {
      let license = this.$store.state.provider.vehicleInfo.licensePlate
      window.open(
    		'#/provider/' + this.provId + '/print-placard?license=' + license,
    		'targetWindow',
    		'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=528,height=842'
    	)
    },
    showBreakdown () {
      let self = this
      let params = {
        id: self.provId,
        type: self.activeTab.right === 1 ? 'history' : 'upcoming'
      }

      self.loading = true
      self.breakdownError = ''
      if (params.type === 'history') {
        self.$store.commit('provider/setProviderBreakdown', { value: [], type: 'deductions' })
        self.$store.commit('provider/setProviderBreakdown', { value: [], type: 'history' })
        ApiProviderReservations.getDeductions(self, params, function (res) {
          if (res.error) {
            self.loading = false
            self.breakdownError = res.error.message
            self.showBreakdownModal = true
            return
          }

          ApiProviderReservations.getAllRsvp(self, params, function (res2) {
            if (res2.error) {
              self.loading = false
              self.breakdownError = res.error.message
              self.showBreakdownModal = true
              return
            }

            self.$store.state.provider.breakdown.deductions.forEach(function (data) {
              self.$store.commit('provider/addProviderBreakdown', {
                type: 'history',
                value: data
              })
            })

            self.showBreakdownModal = true
            self.loading = false
          })

        })
      } else {
        self.$store.commit('provider/setProviderBreakdown', { value: [], type: 'upcoming' })
        ApiProviderReservations.getAllRsvp(self, params, function (res2) {
          if (res2.error) {
            self.loading = false
            self.breakdownError = res.error.message
            self.showBreakdownModal = true
            return
          }

          self.showBreakdownModal = true
          self.loading = false
        })
      }
    },
    totalBreakdown (field) {
      let type = this.activeTab.right === 1 ? 'history' : 'upcoming'
      let list = this.$store.state.provider.breakdown[type]

      let total = 0
      list.forEach(function (item) {
        total += item[field]
      })
      return total
    },
    totalOverall () {
      let total = this.totalBreakdown('amount') + this.totalBreakdown('pickupFee') +
        this.totalBreakdown('bonusAmount') + this.totalBreakdown('tip') +
        this.totalBreakdown('releaseBonus') + this.totalBreakdown('gasFee')
      total = total - this.totalBreakdown('deductions')
      return this.toFixed(total)
    },
    saveServices () {
      if (this.$refs.services.save()) {
        this.$refs.services.save()
      }
    },
    closeServiceModal () {
      let self = this
      self.$store.commit('provider/serviceSaveModal', false)
      setTimeout(() => {
        self.$store.commit('provider/serviceSaveSuccess', {
          success: false,
          message: ''
        })
      }, 500)
    },
    confirmModal () {
      if (!this.editEnabled) { return }
      this.showActiveModal = true
    },
    toggleLogs () { this.showLogs = !this.showLogs },
    toggleQuickRes () {
      let self = this
      if (self.quickRes.loading) { return }
      self.$store.commit('provider/setQuickResData', {loading: true})
      if (self.quickRes.enable) {
        self.$sdk.delete(`/provider/${self.provId}/quickres`, {
          token: self.$store.state.session.sessionToken
        }, res => {
          self.$store.commit('provider/setQuickResData', {loading: false})
          if (!res.error) {
            self.$store.commit('provider/setQuickResData', {
              modal: false,
              enable: false
            })
          }
        })
      } else {
        self.$sdk.post(`/provider/${self.provId}/quickres`, {
          token: self.$store.state.session.sessionToken
        }, res => {
          self.$store.commit('provider/setQuickResData', {loading: false})
          if (!res.error) {
            self.$store.commit('provider/setQuickResData', {
              modal: false,
              enable: true
            })
          }
        })
      }
    },
    closeQuickResModal () {
      if (this.quickRes.loading) { return }
       self.$store.commit('provider/setQuickResData', {modal: false})
    },
    getNextDriverNum () {
      let self = this
      if (self.driverIdLoading) { return }
      self.driverIdLoading = true
      self.$sdk.get('/provider/nextNum', {
        token: self.$store.state.session.sessionToken
      }, res => {
        self.driverIdLoading = false
        if (!res.error) {
          self.driverId = res.next
          self.nextDriverId = res.next
          return
        }
      })
    },
    dlProfile (brand = 'ptrs') {
      window.open(
        `?brand=${brand}#/provider/${this.provId}/download`,
        'targetWindow',
        'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=1122'
      )
    },
    isBefore2026 (x) {
      let year = moment(x, 'MM/DD/YYYY').format('YYYY')
      year = parseInt(year)
      return year < 2026
    }
  },
  watch: {
    provId: function (value) {
      this.nextDriverId = ''
      this.init()
      this.showLogs = false
      this.logDate = 'all'
    },
    logDate: function (value) {
      // if (this.$refs.logs.dateToggle(value)) {
      //   this.$refs.logs.dateToggle(value)
      // }
    }
  },
  mounted () {
    this.init()

    if (this.$refs.upcoming.init()) {
      this.$refs.upcoming.init()
    }
  }
}
</script>

<style lang="scss" scoped>
$fix-button-height: 60px;

.clear{ clear:both; }
.heading{
  height: 50px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  padding: 10px 0;

  & > span{
    padding: 0 5px 0 15px;
  }
  select{
    width: auto;
    float: right;
    font-size: 16px;
    margin-top: 5px;
    margin-right: 40px;
  }
}

.switch{
  position: relative;
  display: inline-block;
  vertical-align: top;

  .slider{
    position: relative;
    display: inline-block;
    width: 50px;
    height: 30px;
    border-radius: 20px;
    background: #ccc;
    position: relative;
    cursor: pointer;
    transition:all .25s ease-in-out;

    &.disabled{ opacity: .4; }
    &:before{
      content: '';
      position: absolute;
      top: 4px;
      left: 4px;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: #fff;
      transition:all .25s ease-in-out;
      box-shadow: 1px 1px 2px rgba(0,0,0, .25);
    }
    &.active{
      background: #57d1b7;
      &:before{ left: 24px; }
    }
  }
  .label{
    display: inline-block;
    vertical-align: 10px;
    margin-left: 5px;
    font-size: 14px;
    color: #555;
    text-transform: uppercase;
  }
}

.prov-options{
  float:right;
  width: 30px;
  height: 40px;
  text-align: center;
  margin-right: 10px;
  cursor: pointer;
  color: #777;
  transition: all .4s ease;
  position: relative;
  z-index: 5;

  .fa-ellipsis-v{ padding: 5px 10px; }
  &:hover{ color: #333; }
  .options{
    transform-origin: top center;
    position: absolute;
    top: 100%;
    right: 0;
    width: 240px;
    background: #fff;
    padding: 10px;
    border-radius: 4px;
    box-shadow: 1px 1px 4px rgba(0,0,0, .2);
  }
}

.call, .send-notif, .print-placard, .send-sms, .download-profile{
  /*float: right;*/
  margin-bottom: 5px;
  text-transform: uppercase;
  i{ margin-right: 5px; }
}

.send-sms { background-color: #16b0de; }
.download-profile { background-color: #ec4545; }

.left-panel{
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 40%;
  height: 100%;
  box-shadow: 2px 0 4px rgba(0,0,0,0.2);
  background-color: #F4F8F9;
  overflow-y: auto;
  padding-bottom: $fix-button-height;

  .heading{ padding-left: 50px; }
}

.toggle-mobile {
  display: none;
}

.tab{
  list-style: none;
  padding: 0;
  margin: 15px 0 0;
  display: flex;
  position: relative;
  z-index: 2;

  li{
    color: #0D79F2;
    padding: 15px 25px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    display: inline-block;
    text-transform: uppercase;
    cursor: pointer;

    &.grow{
      flex-grow: 100;
    }
    &.active{
      background: #fff;
      box-shadow: 0 -1px 2px rgba(0,0,0, .1);
      border-radius: 2px 2px 0 0;
      color: #777;
    }
  }
}

.left-panel .tab li{ width: 25%; }

.tab-contents{
  background: #fff;
  z-index: 2;
  position: relative;
  box-shadow: 0 0 2px 1px rgba(0,0,0, .1);

  .tab-content{
    padding: 20px;
    display: none;

    &.no-H-padding{ padding: 20px 0; }
    &.active{
      display: block;
    }
  }
  .fixed-footer{
    position: fixed;
    bottom: 0;
    right: 0;
    width: 60%;
    padding: 15px;
    background: #313131;
    color: #eee;
    font-size: 18px;
    line-height: 1;
    text-align: center;

    span{
      color: #36a2ff;
      cursor: pointer;
    }
    b{
      font-size: 21px;
      margin-left: 5px;
    }
    i{ margin-left: 3px; }
  }
}

.right-panel{
  position: fixed;
  z-index: 2;
  right: 0;
  top: 0;
  width: 60%;
  height: 100%;
  box-shadow: -2px 0 4px rgba(0,0,0,0.2);
  background-color: #d5d5d5;
  overflow-y: auto;

  .heading{
    font-size:24px;
    padding: 10px 20px;
  }

  .tab{
    background: #d5d5d5;
    & .active{ background: #ededed; }
  }
  .tab-contents{ background: #ededed; }
}

.fix-buttons{
  position: fixed;
  z-index: 3;
  bottom: 0;
  left: 0;
  padding: 10px;
  width: 40%;
  height: $fix-button-height;
  background: #eee;
  box-sizing: border-box;
  display: flex;

  a{
    width: 50%;
    display: inline-block;
    margin: 0 auto;

    &.right{ margin-left: auto; }
  }
}

.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .5);
  display: none;
  z-index: 12;

  .bg-overlay{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
  }
  .modal-content{
    position: absolute;
    top: 45%;
    left: 50%;
    width: 400px;
    padding: 25px;
    background: #fff;
    text-align: center;
    border-radius: 6px;
    margin-left: -200px;
    box-shadow: 1px 1px 5px 2px rgba(0,0,0, .3);
    display: none;

    &.upload{
      top: 50%;
      width: 900px;
      height: 550px;
      margin-top: -265px;
      margin-left: -450px;

    }
  }
  &.no-preview .upload{
    height: 150px;
    margin-top: -75px;
  }
  &.show{
    display: block;

    .modal-content{
      display: block;
      -webkit-animation: slide-down .3s ease-out;
      -moz-animation: slide-down .3s ease-out;
    }
  }
}
.service-save{
  i{
    display: block;
    margin-bottom: 5px;
  }
  .fa-check-circle{ color: #1bd35d; }
  .fa-times-circle{ color: #ea4949; }
  span{
    margin-bottom: 10px;
    display: block;
  }
  p{
    padding: 3px;
    margin: 0 0 15px;
    background: #ea4949;
    color: #fff;
    font-size: 14px;
    border-radius: 4px;
  }
  .button{
    margin-top: 10px;
  }
}

.breakdown{
  overflow: auto;

  .modal-content{
    max-width: 800px;
    width: 100%;
    position: relative;
    top: 20px;
    left: 0;
    margin: 0 auto;
  }
  .has-error{
    i{ color: #fb4040; }
    span{
      display: block;
      font-size: 21px;
      margin: 10px 0 15px;
    }
    p{
      line-height: 135%;
      padding: 0;
      margin: 0 0 20px;
      color: #777;
    }
  }
  .label{
    font-size: 21px;
    margin-bottom: 20px;
    font-weight: 600;
    color: #0D79F2;
  }
  .list{
    width: 100%;

    thead{
      font-weight: 600;
      color: #999;
      font-size: 14px;
      td{
        border-bottom: 1px solid #ccc;
        padding: 3px 2px;
      }
    }
    tbody{
      font-size: 14px;
      tr{ transition: all .1s linear; }
      tr:hover{ background: #e2f3ff; }
      a{ font-size:13px; }
      a.pkg{ color: #14ab3b; }
      td{
        padding: 3px 0;
        text-align: center;
      }
      .total{
        td{
          border-top:1px solid #ccc;
          font-weight: 600;
        }
      }
    }
  }
  .computations{
    float: right;
    margin: 20px 0;
    border:1px solid #eee;
    background: #fafafa;
    padding: 10px;
    box-shadow: 0 0 3px 1px rgba(0,0,0, .2);

    td{ padding: 2px 20px; }
    td:first-child{ text-align: right; }
    td:last-child{
      text-align: right;
      padding-left: 20px;
    }
    .total{
      td{
        border-top: 1px solid #aaa;
        font-size: 21px;
        font-weight: 600;
        color: #e44e4e;
      }
    }
  }
}

@-webkit-keyframes slide-down {
  0% { opacity: 0; -webkit-transform: translateY(100%); }
  100% { opacity: 1; -webkit-transform: translateY(0); }
}
@-moz-keyframes slide-down {
  0% { opacity: 0; -moz-transform: translateY(100%); }
  100% { opacity: 1; -moz-transform: translateY(0); }
}

.active-confirmation{
  p{
    margin-top: 0;
    font-size: 18px;
  }
  .button{
    width: 40%;
    margin: 0 5px;
  }
}

.formResult{
  p{
    margin: 0 0 40px;
    font-size: 18px;
    color: #333;
  }
}

.upload{
  .input-file{
    margin: 0 0 15px;
    font-size: 14px;
    padding: 5px;
    background: #fafafa;
    box-shadow: 1px 1px 2px rgba(0,0,0, .1) inset;
  }

  .cropper-wrap{
    display: flex;
    width: 100%;
    margin-bottom: 15px;
    padding-top: 20px;
  }
  .upload-side, .preview-side{
    position: relative;
    display: inline-block;
    width: 50%;
    max-height: 380px;
    vertical-align: top;
    background: #555;

    ._label{
      position: absolute;
      top: -22px;
      left: 0;
      font-weight: 600;
      font-size: 14px;
      color: #777;
      width: 100%;
      text-align: center;
    }
  }
  .preview-side{
    margin-left: 10px;

    img{
      position: relative;
      -webkit-transform: translateY(-50%);
     transform: translateY(-50%);
     top: 50%;
     max-width: 420px;
     max-height: 380px;
    }
  }

  .button.cta{
    width: 200px;
    margin: 0 5px;
  }
}

.uploadError{
  text-align: center;

  p{
    margin-top: 0;
    color: #f20d0d;
    font-weight: 600;
  }
  .fa{
    display: block;
    color: #999;
    margin-bottom: 5px;
  }
}

$toggle-size: 50px;
.logs-toggle {
  position: fixed;
  right: 0;
  top: 0;
  z-index: 3;
  width: $toggle-size;
  height: $toggle-size;
  line-height: $toggle-size;
  text-align: center;
  color: #777;
  transition: all 250ms;
  border-radius: 0;
  background-color: #F25E0D;
  color: #fff;
  border-bottom-left-radius: 3px;
  box-shadow: -2px 0 8px rgba(0,0,0,0.35);
  cursor: pointer;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease;
  -moz-transition: .5s ease;
  -o-transition: .5s ease;
  transition: .5s ease;

  i { line-height: inherit; }

  &.on{
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    transform: rotate(90deg);
    -webkit-transition: .5s ease;
    -moz-transition: .5s ease;
    -o-transition: .5s ease;
    transition: .5s ease;
  }
}
$right-panel-width: 400px;
.logs-panel{
  position: fixed;
  z-index: 2;
  right: 0;
  top: 0;
  width: $right-panel-width;
  height: 100%;
  box-shadow: -2px 0 4px rgba(0,0,0,0.2);
  background-color: #f4f8f9;
  transition: all .6s ease;

  &.hide{
    right: -#{$right-panel-width};
    box-shadow: -2px 0 8px rgba(0,0,0,0.0);
  }
  .heading{
    font-size:24px;
    padding: 10px 20px;
    margin-bottom: 7px;
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .45s ease; }
.slide-up-enter, .slide-up-leave-to { transform: translateY(80px); }

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to { transform: translateY(-10px); }

@media only screen and (max-width: 430px) {
  .left-panel {
    width: 100%;
    padding-bottom: 100px;
    .heading {
      height: auto;
      .switch {
        display: block;
        padding-top: 5px;
        padding-left: 10px;
      }

      .prov-options {
        position: absolute;
        right: 0;
        top: 15px;
      }
    }

    .tab {
      margin: 20px 0 0;
      display: flex;
      overflow-x: scroll;

      li {
        width: auto;
      }
    }
  }

  .toggle-mobile {
    display: block;
    color: #fff;
    background-color: #333;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 8px 0;
    height: 45px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 9;
    text-transform: uppercase;
    font-weight: 900;
  }

  .right-panel {
    z-index: 1;
    width: 100%;
    top: 100%;
    transition: all 0.3s ease;

    &.mobile-right-panel {
      top: 0;
      z-index: 2;

      .tab {
        margin-top: 70px;
        display: flex;
        overflow-x: scroll;

        li {
          white-space: nowrap;
        }
      }

      .tab-contents {
        width: 100%;
        .tab-content {
          padding-bottom: 100px;

          &.history-panel {
            padding: 0;
            padding-top: 20px;
            padding-bottom: 60px;
          }

        }
        .fixed-footer {
          width: 100%;
          bottom: 45px;
          background: #fff;
          color: #000;
          border-top: 1px solid #aaa;
        }
      }

      .logs-panel {
        width: 100%;
        &.hide {
          right: -430px;
        }
      }
    }
  }

  .fix-buttons {
    width: 100%;
    bottom: 45px;
    a {
      margin: 0 auto;
    }
  }
}
.dl-profile{
  position: fixed;
  right: 100%;
  top: 0;
  // z-index: 999;
  // width: 793px;
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/index.vue